import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./UserManagement.css";
import UserManagementTable from "./UserManagementTable/UserManagementTable";

const UserManagement = () => {
  const navigate = useNavigate();

  const handleBackToDashboard = () => navigate("/dashboard");
  const handleLogout = () => {
    fetch(`${process.env.REACT_APP_BACKEND_FLASK_API_URL}/logout`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data.message);
        navigate(`/`);
      })
      .catch((error) => console.error("Error logging out:", error));
  };

  return (
    <div className="user-management">
      <div className="dash-header">
        <button onClick={handleBackToDashboard}>Dashboard</button>
        <button onClick={handleLogout}>Log Out</button>
      </div>

      <h2>User Management</h2>

      <UserManagementTable />
    </div>
  );
};

export default UserManagement;
